import React from 'react';
import {
    Box,
    Heading,
    Text,
    Stack,
    Badge,
    SimpleGrid,
    Spinner,
    Divider, Th, Tbody, Tr, Td, Table, Thead,
} from '@chakra-ui/react';
import {useQuery} from "@tanstack/react-query";
import {getUsedPromoCodesPerUser} from "../../services/affiliate";
import { getPartnerDisplayName } from "../../utils/userProfile";
import { formatDateShortCET } from "../../utils/helpers";

const AdminPromoCodesDashboard = () => {

    const { data, isFetching, isLoading } = useQuery(
        ["getPromoCodes"],
        () =>
            getUsedPromoCodesPerUser(),
        {
            //keepPreviousData: true,
            refetchOnWindowFocus: false,
            select: (data) => data.data,
            onSuccess: (data) => {
            },
            enabled: true,
        }
    );

    if (isLoading || isFetching) {
        return <Spinner size="xl" color="teal.500" />;
    }

    return (
        <Box p={8}>
            <Heading mb={6} color="teal.600">Affiliate Promo Codes Dashboard</Heading>

            {data.length === 0 ? (
                <Text>No promo codes found.</Text>
            ) : (
                <Stack spacing={8}>
                    {data.map((user) => {
                        const totalCommission = user.promoCodes.reduce(
                            (sum, code) => sum + code.totalCommission,
                            0
                        );

                        return (
                            <Box key={user.id} p={6} shadow="md" borderWidth="1px" borderRadius="lg">
                                <Stack spacing={2} mb={4}>
                                    <Heading size="md">{getPartnerDisplayName(user)}</Heading>
                                    <Text>Email: <Badge colorScheme="teal">{user.email}</Badge></Text>
                                    <Text>Tel. number: <Badge colorScheme="teal">{user.telephoneNumber}</Badge></Text>
                                    <Text fontWeight="bold" color="teal.600">
                                        💰 Total amount to be paid: EUR {totalCommission.toFixed(2)}
                                    </Text>
                                </Stack>

                                <Divider mb={4} />

                                <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                                    {user.promoCodes.map((code) => (
                                        <Box
                                            key={code.id}
                                            borderWidth="1px"
                                            borderRadius="md"
                                            p={4}
                                            bg="white"
                                            shadow="sm"
                                        >
                                            <Heading size="sm" mb={2} color="teal.700">
                                                {code.code}
                                            </Heading>
                                            <Text>Discount: {code.discountAmount * 100}%</Text>
                                            <Text>Active: {code.active ? 'Yes' : 'No'}</Text>
                                            <Text>Usage Count: {code.usageCount}</Text>
                                            <Text fontWeight="bold" mt={2}>
                                                Commission: EUR {code.totalCommission.toFixed(2)}
                                            </Text>

                                            {code.bookings?.length > 0 && (
                                                <Box mt={3} overflowX="auto" maxHeight="400px" overflowY="auto">
                                                    <Text fontWeight="semibold" mb={3}>Successful reservations with promo code {code.code} used:</Text>
                                                    <Table variant="simple">
                                                        <Thead>
                                                            <Tr>
                                                                <Th
                                                                    position="sticky"
                                                                    left="0"
                                                                    bg="white"
                                                                    zIndex="docked"
                                                                    minWidth="120px"
                                                                >
                                                                    Booking ID
                                                                </Th>
                                                                <Th>Start Date</Th>
                                                                <Th>End Date</Th>
                                                            </Tr>
                                                        </Thead>
                                                        <Tbody>
                                                            {code.bookings.map((b) => (
                                                                <Tr key={b.id}>
                                                                    <Td
                                                                        position="sticky"
                                                                        left="0"
                                                                        bg="white"
                                                                        zIndex="docked"
                                                                        minWidth="120px"
                                                                    >
                                                                        {b.referenceNumber}
                                                                    </Td>
                                                                    <Td>{formatDateShortCET(b.startDate)}</Td>
                                                                    <Td>{formatDateShortCET(b.endDate)}</Td>
                                                                </Tr>
                                                            ))}
                                                        </Tbody>
                                                    </Table>
                                                </Box>
                                            )}

                                        </Box>
                                    ))}
                                </SimpleGrid>
                            </Box>
                        );
                    })}
                </Stack>
            )}
        </Box>
    );
};

export default AdminPromoCodesDashboard;
